"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_1 = require("@angular/platform-browser");
var SafeUrlPipe = /** @class */ (function () {
    function SafeUrlPipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    SafeUrlPipe.prototype.transform = function (url, args) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    SafeUrlPipe.ctorParameters = function () { return [{ type: platform_browser_1.DomSanitizer }]; };
    return SafeUrlPipe;
}());
exports.SafeUrlPipe = SafeUrlPipe;
//# sourceMappingURL=safe-url.pipe.js.map


// WEBPACK FOOTER //
// safe-url.pipe.js